__webpack_require__.p = "/Merchant2/themes/shadows/v1.54.5/public/dist/";